module.exports = __webpack_public_path__ + "static/img/y6.f532f84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/y6.png
// module id = XT42
// module chunks = 1